/*
 * 이미지 주소 변환 — 🔑 **순수 모듈**입니다(`"use client"` 도 `server-only` 도 아님).
 * 서버(`layout.tsx` 의 파비콘)와 화면(`api.ts` 가 다시 내보냄) 둘 다 씁니다 (2026-09-23 분리).
 */

/**
 * `api.` 가 준 이미지 상대 경로를 BFF 주소로 바꿉니다.
 *
 * 🔴 배너(`/banners/{id}/image`)도, 우리 상품 카드 사진(`/images/products/…`)도
 *    `api.` 가 내려주는 **상대 경로**입니다. 그대로 `<img src>` 에 넣으면 몰의
 *    같은 경로를 찾아가 404 입니다 — 이미지는 `api.` 에 있고, 거기로 가려면
 *    키를 든 BFF 를 거쳐야 합니다.
 *
 * 🔑 **이름을 `bannerImageSrc` 에서 일반화했습니다** (2026-09-13 — 상품 카드
 *    실사 이미지를 다시 들이며 `ProductCard`/`WalletCard` 에도 같은 변환이
 *    필요해졌습니다). 배너 전용이 아니라 "상대 경로 이미지 전부" 를 다룹니다.
 */
export function mediaSrc(imageUrl: string | null | undefined): string | null {
  if (!imageUrl) return null;
  /* 이미 절대 주소면 그대로 (외부 CDN 을 쓰는 납품처가 있을 수 있습니다). */
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  /*
   * 🆕 이미지 데이터 URL 도 그대로 (2026-09-23 · `/preview`). 인트라넷 «몰 설정» 이 저장 전의
   *    로고·히어로를 `postMessage` 로 보내면 미리보기가 그 값을 여기로 흘립니다.
   *    🔴 `data:image/…` 만입니다 — 그 밖의 `data:` 는 BFF 경로로 붙여 결국 404 가 됩니다.
   *    `<img src>` 에 들어가는 값이라 SVG 라도 스크립트가 돌지 않습니다.
   */
  if (/^data:image\//i.test(imageUrl)) return imageUrl;
  return `/bff${imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`}`;
}
